var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { LeadMapsActions } from '../actions/index';
var initialState = { basin: null, country: null };
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case LeadMapsActions.LeadMapActionTypes.Basin:
            return __assign({}, state, { basin: action.payload });
        case LeadMapsActions.LeadMapActionTypes.Country:
            return __assign({}, state, { basin: action.payload });
        default: {
            return state;
        }
    }
}
